/** Check if url is relative. */
export const isRelative = (url: string) => url.charAt(0) === '.';
